<template>
  <div class="div" v-loading="loading">
    <!-- <div class="title">资产信息</div> -->
    <div class="div-top">
      <el-button icon="el-icon-plus" type="primary" @click="handleAdd"
        >新建处置</el-button
      >
      <el-button
        icon="el-icon-minus"
        type="danger"
        @click="handleDetele(selectedRows)"
        :disabled="selectedRows.length === 0"
        >删除</el-button
      >
      <el-input
        v-model="Code"
        clearable
        placeholder="请输入资产编号/名称"
        style="width: 300px; margin-left: 10px"
      ></el-input>
      <el-date-picker
        style="width: 300px; margin-left: 10px"
        v-model="searchData"
        value-format="yyyy-MM-dd"
        type="monthrange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="handleDateChange"
      >
      </el-date-picker>
      <el-button type="primary" @click="handleSearch" style="margin-left: 10px"
        >查询</el-button
      >
    </div>
    <div class="div-center">
      <el-table
        :data="tableData"
        ref="table"
        style="width: 100%"
        height="calc(100% - 40px)"
        @selection-change="handleSelect"
      >
        <el-table-column label="" width="50" type="selection">
        </el-table-column>
        <el-table-column label="序号" width="50" type="index">
        </el-table-column>
        <el-table-column
          label="处置单编号"
          align="center"
          prop="ScrapCode"
          sortable
        ></el-table-column>
        <el-table-column
          label="处置日期"
          align="center"
          prop="ScrapDate"
          sortable
        >
          <template slot-scope="scope">
            {{
              scope.row.ScrapDate
                ? moment(scope.row.ScrapDate).format('YYYY-MM-DD')
                : ''
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="处置类型"
          width="160"
          align="center"
          prop="ScrapTypeName"
          sortable
        ></el-table-column>
        <el-table-column
          label="资产编码"
          width="160"
          align="center"
          prop="AssetCode"
          sortable
        ></el-table-column>
        <el-table-column
          label="资产名称"
          width="160"
          align="center"
          prop="AssetName"
          sortable
        ></el-table-column>
        <el-table-column
          label="处置人"
          align="center"
          prop="DisposalPerson"
          sortable
        ></el-table-column>
        <el-table-column
          label="处置原因"
          align="center"
          prop="ScrapRemarks"
        ></el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button
              type="text"
              v-if="scope.row.Status === 0"
              @click="handleEdit(scope.row, false)"
              >编辑</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Status === 1"
              @click="handleEdit(scope.row, true)"
              >查看</el-button
            >
            <el-button
              type="text"
              v-if="scope.row.Status === 0"
              @click="handleDetele([scope.row])"
              style="color: #f78989"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div
        style="
          height: 40px;
          display: flex;
          align-items: center;
          justify-content: right;
        "
      >
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.PageIndex"
          :page-sizes="pagination.PageSizes"
          :page-size="pagination.PageRows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    <EditForm ref="EditForm" @success="handleSearch" />
  </div>
</template>
<script>
import EditForm from './EditForm'
import moment from 'moment'
import { mapState } from 'vuex'
export default {
  data() {
    return {
      moment,
      searchData: [],
      tableData: [],
      Code: '',
      pagination: {
        PageIndex: 1,
        PageRows: 20,
        PageSizes: [20, 40, 60, 100],
        total: 0,
      },
      selectedRows: [],
      loading: false,
    }
  },
  props: {},
  components: { EditForm },
  methods: {
    handleDateChange(value) {
      // 无论是否为同一个月，结束日期都应为月末日期
      if (value && value.length === 2) {
        const startDate = moment(value[0])
        const endDate = moment(value[1])
        // 设置开始日期为选择月份的第一天
        const firstDay = startDate.startOf('month').format('YYYY-MM-DD')
        // 设置结束日期为选择月份的最后一天
        const lastDay = endDate.endOf('month').format('YYYY-MM-DD')
        this.searchData = [firstDay, lastDay]
      }
    },
    handleSelect(selection) {
      this.selectedRows = selection
    },
    getDataList() {
      this.selectedRows = []
      this.loading = true
      this.$http
        .post('/AM/AM_AssetDisposal/GetDataList', {
          PageIndex: this.pagination.PageIndex,
          PageRows: this.pagination.PageRows,
          SortField: 'CreateTime',
          SortType: 'Desc',
          Search: {
            Keyword: this.Code,
            StartDate: this.searchData?.length > 0 ? this.searchData[0] : '',
            EndDate: this.searchData?.length > 0 ? this.searchData[1] : '',
            Type: this.AssetTreeSeacrh || '',
          },
        })
        .then((resJson) => {
          this.loading = false
          if (resJson.Success) {
            this.tableData = resJson.Data
            this.pagination.total = resJson.Total
            this.$nextTick(() => {
              if (this.$refs.table) {
                this.$refs.table.clearSelection()
              }
            })
          } else {
            this.$notify.error(resJson.Msg)
          }
        })
    },
    handleSearch() {
      this.pagination.PageIndex = 1
      this.getDataList()
    },
    handleCurrentChange(PageIndex) {
      this.pagination.PageIndex = PageIndex
      this.getDataList()
    },
    handleSizeChange(PageRows) {
      this.pagination.PageIndex = 1
      this.pagination.PageRows = PageRows
      this.getDataList()
    },
    handleAdd() {
      this.$refs.EditForm.openForm('新建资产处置', null)
    },
    handleDetele(rows) {
      let ids = rows.map((item) => item.Id)
      this.$confirm(`此操作将永久删除该资产处置, 是否继续?`, {
        type: 'warning',
      })
        .then(() => {
          this.loading = true
          this.$http
            .post('/AM/AM_AssetDisposal/DeleteData', ids)
            .then((resJson) => {
              this.loading = false
              if (resJson.Success) {
                this.$notify.success('删除成功')
                this.getDataList()
              } else {
                this.$notify.error(resJson.Msg)
              }
            })
        })
        .catch(() => {})
    },
    handleEdit(row, flag) {
      this.$refs.EditForm.openForm(
        flag ? '查看资产处置' : '编辑资产处置',
        row.Id,
        flag
      )
    },
  },
  mounted() {},
  created() {
    this.getDataList()
  },
  computed: {
    ...mapState(['AssetTreeSeacrh']),
  },
  watch: {
    AssetTreeSeacrh() {
      this.handleSearch()
    },
  },
}
</script>
<style lang="scss" scoped>
.div-top,
.div-search {
  // height: 30px;
  line-height: 30px;
}
.div-search {
  margin-top: 10px;
}
.div-center {
  margin-top: 10px;
  height: calc(100% - 30px);
}
.title {
  font-size: 20px;
  font-weight: bold;
  line-height: 40px;
}
</style>
